export default "__VITE_ASSET__Bdj7C1XQ__"